<template>
    <div class="view">
        <SubPages :parent-route="parentRoute"></SubPages>
    </div>
</template>

<script>
  import RoutesUtils from "@/utils/routesUtil";
  import SubPages from "../../components/SubPages";

  export default {
    components: {
      SubPages,
    },
    data() {
      return {
        parentRoute: RoutesUtils.getRouteByName('Utilisateurs'),
      }
    }
  }
</script>

